// extracted by mini-css-extract-plugin
export default {"Logo":"FlohmarktLogo_Logo__+cK1L","LogoBaseline":"FlohmarktLogo_LogoBaseline__MmSO8","LogoSize":"FlohmarktLogo_LogoSize__XR7in"};